import React from 'react';

interface Props {
  className?: string;
}

const EditIcon: React.FC<Props> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.707 19.7076L18 10.4146L13.586 6.00061L4.293 15.2936C4.16506 15.4217 4.07418 15.582 4.03 15.7576L3 21.0006L8.242 19.9706C8.418 19.9266 8.579 19.8356 8.707 19.7076ZM21 7.41461C21.3749 7.03956 21.5856 6.53094 21.5856 6.00061C21.5856 5.47028 21.3749 4.96167 21 4.58661L19.414 3.00061C19.0389 2.62567 18.5303 2.41504 18 2.41504C17.4697 2.41504 16.9611 2.62567 16.586 3.00061L15 4.58661L19.414 9.00061L21 7.41461Z"
        fill="black"
      />
    </svg>
  );
};

export default EditIcon;
